import React from 'react'

import * as S from './styles'
import { StarScore } from '../starScore'
import { Text } from '@/components/text'

export type NumericalCardProps = {
  /**
   * Background color of the card
   * @default ${theme.colors.black}
   *
   * @example
   * ```tsx
   * <NumericalCard backgroundColor="#000" />
   * ```
   */
  backgroundColor?: string

  /**
   * Title color
   * @default ${theme.colors.black}
   *
   * @example
   * ```tsx
   * <NumericalCard titleColor="#000" />
   * ```
   */
  titleColor?: string

  /**
   * Title color
   * @default ${theme.colors.black}
   *
   * @example
   * ```tsx
   * <NumericalCard titleColor="#000" />
   * ```
   */
  descriptionColor?: string

  /**
   * Title of the card
   *
   * @example
   * ```tsx
   * <NumericalCard title="Title" />
   * ```
   */
  title: string

  /**
   * Description of the card
   *
   * @example
   * ```tsx
   * <NumericalCard description="Description" />
   * ```
   */
  description?: string

  /**
   * Array used to draw stars
   *
   * @example
   * ```tsx
   * <NumericalCard starsScoreArray={[100,100,100,100,55]}/>
   * ```
   */
  starsScoreArray?: number[]
  subtitle?: string
}

export const NumericalCard: React.FC<NumericalCardProps> = ({
  backgroundColor,
  titleColor,
  descriptionColor,
  title,
  description,
  starsScoreArray = [],
  subtitle,
}) => (
  <S.NumericalCard
    backgroundColor={backgroundColor}
    titleColor={titleColor}
    descriptionColor={descriptionColor}
  >
    <Text size="h4" className="numerical-card-title">
      {title}
      {subtitle && (
        <Text size="b4" className="subtitle">
          {subtitle}
        </Text>
      )}
    </Text>

    {!!starsScoreArray?.length && (
      <S.StarScoreContainer>
        <StarScore
          filledColor={titleColor}
          backgroundColor={descriptionColor}
          starsScoreArray={starsScoreArray}
        />
      </S.StarScoreContainer>
    )}

    {!!description && (
      <Text size="b3" className="numerical-card-description">
        {description}
      </Text>
    )}
  </S.NumericalCard>
)
